// @flow
import * as React from 'react';

type Props<T> = {|
  children: (results: Array<T>) => React.Node,
  results: ?Array<T>, // Array if results have been determined. null of undefined otherwise.
|};

type State<T> = {|
  results: Array<T>,
|};

export default class TypeaheadCache<T> extends React.PureComponent<Props<T>, State<T>> {
  state: State<T> = {
    results: [],
  };

  static getDerivedStateFromProps(
    { results: currentResults }: Props<T>,
    { results: previousResults }: State<T>,
  ) {
    return { results: currentResults || previousResults || [] };
  }
  render() {
    return this.props.children(this.state.results);
  }
}
